
/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import Loader from '../components/common/loader/loader';
import { useMyVW } from '../../context/myVWContext';
import { SessionContext } from '../../context/sessionContext';
import verifyCustomerLinked from '../services/verifyCustomerLinked';
import MyVWStatusDisplay from './myVWStatusDisplay';
import MyVWMaintenance from '../components/myVW/MyVWMaintenance';
import i18n from '../../localization/i18n';
import * as rk from '../../localization/resourceKeys';
import Logger from '../../logger';
import { useMyVWBootstrap } from '../hooks/useMyVWBootstrap';
import { StepLayout } from '../components/common/steplayout/StepLayout';
import getMaintenanceMode from '../../utilities';

const MyVWLanding: React.FC = () => {
  const [searchParams] = useSearchParams();

  const location = useLocation();
  const originalSearch = location.search;
  const { isLinked, setIsLinked, applyAuthState, vwfsToken } = useMyVW();

  const sessionContext = useContext(SessionContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [inMaintenanceMode, setInMaintenanceMode] = useState(false);

  const { token, brand, country } = useMyVWBootstrap();

  const openInNewTabParam = searchParams.get('openInNewTab');
  const openInNewTab = openInNewTabParam?.toLowerCase() !== 'false';

  const normalizedBrand = brand.toUpperCase();
  const correlationId = sessionContext?.sessionDetails?.correlationId ?? '';

  useEffect(() => {
    const check = async () => {
      const isInMaintenance = await getMaintenanceMode();
      if (isInMaintenance) {
        setInMaintenanceMode(true);
        setLoading(false);
        return;
      }

      Logger.info(
        'myVW landing: starting link-status API check',
        'Location ==> /myVW',
        sessionContext?.sessionDetails,
      );

      const result = await verifyCustomerLinked({
        Brand: normalizedBrand,
        CorrelationId: correlationId,
        Country: country,
        token,
      });

      setLoading(false);

      if (result.error) {
        Logger.error(
          'myVW landing: link-status API check failed',
          'Location ==> /myVW',
          result.error,
          sessionContext?.sessionDetails,
        );
        setError(i18n.t(rk.ERROR_MYVW_CHECK_FAILED));
        return;
      }

      if (typeof result.isLinked !== 'boolean') {
        Logger.error(
          'myVW landing: link-status API returned non-boolean value',
          'Location ==> /myVW',
          'Expected boolean isLinked value',
          sessionContext?.sessionDetails,
        );
        setError(i18n.t(rk.ERROR_MYVW_CHECK_FAILED));
        return;
      }

      Logger.info(
        `myVW landing: link-status API resolved isLinked=${result.isLinked}`,
        'Location ==> /myVW',
        sessionContext?.sessionDetails,
      );

      setIsLinked(result.isLinked);

      if (result.isLinked) {
        applyAuthState({
          partyId: result.partyId ?? null,
          externalId: result.externalId ?? '',
          brand: result.brand ?? normalizedBrand,
          country: result.country ?? country,
          vwfsToken: token,
        });
      }
    };

    check();
  }, []);
    
  if (inMaintenanceMode) {
    return <MyVWMaintenance />;
  }

  if (error) {
    return (
      <StepLayout brand={brand} country={country}>
        <div className={`container u-ph-small`}>
          <p className="c-error-message u-mt">{error}</p>
        </div>
      </StepLayout>
    );
  }

  if (loading || isLinked === null) {
    return <Loader isLoading />;
  }

  return <MyVWStatusDisplay isLinked={isLinked} originalSearch={originalSearch} openInNewTab={openInNewTab} vwfsToken={vwfsToken} />;
};

export default MyVWLanding;

